import {call, put, takeEvery, all, fork, select, take} from 'redux-saga/effects';
import {postStreaming} from "../../helpers/api_helper";
import * as url from "../../helpers/url_helper";
import {
  GET_ALERT_LOG_DETAILS,
  GET_ALERT_LOGS,
  POST_ACKNOWLEDGE_ALERT,
  POST_RESOLVE_ALERT,
  SELECT_ALERT,
  GET_ALERT_LOGS_COUNT,
  GET_RUNBOOK,
  POST_RUNBOOK_FEEDBACK,
  GET_RUNBOOK_FEEDBACKS,
  POST_RUNBOOK,
  UPDATE_RUNBOOK,
  GET_INTEGRATION_TYPES,
  GET_ALERT_CORRELATION,
  GET_ERROR_LOGS,
  GET_METRIC_DATA_BY_ALERT_LOG_ID,
  GET_RUNBOOK_RESULTS_ALERT_LOG_ID,
  GET_RUNBOOK_BY_RUNBOOK_ID_SUCCESS,
  GET_RUNBOOK_BY_RUNBOOK_ID,
  GET_ALERT_LOG_STATUS_HISTORY,
  EXECUTE_RUNBOOK_STEP,
  START_AI_CONVERSATION,
  GET_PAST_AI_CONVERSATION,
  GET_AGENT_AVAILABILITY_FOR_ALERT_LOG,
  GET_USER_EXECUTED_RESULTS_ALERT_LOG_ID, SEND_APPROVAL_DECISION,
} from './actionTypes';
import {
  getAlertLogDetailsFail,
  getAlertLogDetailsSuccess,
  getAlertLogsFail,
  getAlertLogsSuccess,
  postAcknowledgeAlert,
  postAcknowledgeAlertFail,
  postAcknowledgeAlertSuccess,
  postResolveAlertFail,
  postResolveAlertSuccess,
  selectAlertByID,
  getAlertLogsCountSuccess,
  getAlertLogsCountFail,
  getRunbookFail,
  getRunbookSuccess,
  postRunbookFeedbackSuccess,
  postRunbookFeedbackFail,
  getRunbookFeedbacksSuccess,
  getRunbookFeedbackFail,
  postRunbookFail,
  postRunbookSuccess,
  updateRunbookSuccess,
  updateRunbookFail,
  getIntegrationTypes,
  getIntegrationTypesFail,
  getIntegrationTypesSuccess,
  getAlertCorrelationSuccess,
  getAlertCorrelationFail,
  getErrorLogsSuccess,
  getErrorLogsFail,
  getMetricDataByAlertLogIdSuccess,
  getMetricDataByAlertLogIdFail,
  getRunbookByRunbookIdSuccess,
  getRunbookByRunbookIdFail,
  getAlertLogStatusHistorySuccess,
  getAlertLogStatusHistoryFail,
  getRunbookStepsResultsByAlertLogIdSuccess,
  getRunbookStepsResultsByAlertLogIdFail,
  executeRunbookStepSuccess,
  executeRunbookStepFail,
  startAiConversationSuccess,
  startAiConversationFail,
  updateAiResponseChunk,
  setAiStreaming,
  clearAiResponse,
  getPastAiConversationsSuccess,
  getPastAiConversationsFail,
  getAgentAvailableSuccess,
  getAgentAvailableFail,
  getUserExecutedStepsResultsByAlertLogIdSuccess,
  getUserExecutedStepsResultsByAlertLogIdFail,
  handleApprovalMessage, sendApprovalDecision,
} from './actions';
import {
  getAlertLogDetailsUrl,
  getAlertLogsUrl,
  postAcknowledgeAlertUrl,
  postResolveAlertUrl,
  getAlertLogsCountUrl,
  getRunbookUrl,
  postRunbookFeedbackUrl,
  getRunbookFeedbacksUrl,
  postRunbookUrl,
  updateRunbookUrl,
  getIntegrationTypesUrl,
  getAlertCorrelationUrl,
  getErrorLogsUrl,
  getMetricDataUrl,
  getAlertLogStatusHistoryUrl,
  getRunbookDetailsUrl,
  getRunbookResultsUrl,
  executeRunbookStepUrl,
  startAiConversationUrl,
  getPastAiConversationsUrl, getCheckAiAvailabilityUrl, getUserExecutedResultsUrl
}
  from "../../helpers/fakebackend_helper";
import {eventChannel} from "redux-saga";
import {GET_ACTION_ITEM_BY_ID} from "../rca/actionTypes";

function* onSelectALert(data) {
 try {
   yield put(selectAlertByID(data.payload))
 } catch (error) {

 }
}

function* onGetAlertLogs({ payload: {pageFilters} }) {
  try {
    const response = yield call(getAlertLogsUrl, pageFilters);
    yield put(getAlertLogsSuccess(response));
  } catch (error) {
    yield put(getAlertLogsFail(error.message));
  }
}

function* onGetAlertLogsCount({ payload: {pageFilters} }) {
  try {
    const response = yield call(getAlertLogsCountUrl, pageFilters);
    yield put(getAlertLogsCountSuccess(response));
  } catch (error) {
    yield put(getAlertLogsCountFail(error.message));
  }
}

function* onPostAcknowledgeAlert({ payload: {alertIds} }) {
  try {
    const response = yield call(postAcknowledgeAlertUrl, alertIds);
    yield put(postAcknowledgeAlertSuccess(response));
  } catch (error) {
    yield put(postAcknowledgeAlertFail(error.message));
  }
}

function* onPostResolveAlert({ payload: {alertIds} }) {
  try {
    const response = yield call(postResolveAlertUrl, alertIds);
    yield put(postResolveAlertSuccess(response));
  } catch (error) {
    yield put(postResolveAlertFail(error.message));
  }
}

function* onGetAlertLogDetails({ payload: {alertId} }) {
  try {
    const response = yield call(getAlertLogDetailsUrl, alertId);
    yield put(getAlertLogDetailsSuccess(response));
  } catch (error) {
    yield put(getAlertLogDetailsFail(error.message));
  }
}

function* onGetRunbook({ payload: {alert_id}}){
  try{
    const response = yield call(getRunbookUrl, alert_id);
    yield put(getRunbookSuccess(response));
  } catch(error) {
    yield put (getRunbookFail(error.message))
  }
}

function* onPostRunbookFeedback({ payload: {data} }){
  try{
    const response = yield call(postRunbookFeedbackUrl, data)
    yield put (postRunbookFeedbackSuccess(response))
  } catch(error){
    yield put (postRunbookFeedbackFail(error.message))
  }
}

function* onPostRunbook({payload: {data}}){
  try{
    const response = yield call(postRunbookUrl, data)
    yield put (postRunbookSuccess(response))
  } catch(error) {
    yield put (postRunbookFail(error.message))
  }
}

function* onUpdateRunbook({payload: {data, id}}){
  try{
    const response = yield call(updateRunbookUrl, data, id)
    yield put (updateRunbookSuccess(response))
  } catch(error) {
    yield put (updateRunbookFail(error.message))
  }
}

function* onGetRunbookFeedbacks({ payload: {runbook_id}}){
  try{
    const response = yield call(getRunbookFeedbacksUrl, runbook_id)
    yield put (getRunbookFeedbacksSuccess(response))
  }catch(error){
    yield put (getRunbookFeedbackFail(error.message))
  }
}

function* onGetIntegrationTypes() {
  try{
    const response = yield call(getIntegrationTypesUrl);
    yield put (getIntegrationTypesSuccess(response));
  }
  catch(error) {
    yield put (getIntegrationTypesFail(error.message))
  }
}

function* onGetAlertCorrelation({ payload: {alertId} }) {
    try {
        const response = yield call(getAlertCorrelationUrl, alertId);
        yield put(getAlertCorrelationSuccess(response));
    } catch (error) {
        yield put(getAlertCorrelationFail(error.message));
    }
}

function* onGetMetricDetails({ payload: {alertId} }) {
  try {
    const response = yield call(getMetricDataUrl, alertId);
    yield put(getMetricDataByAlertLogIdSuccess(response));
  } catch (error) {
    yield put(getMetricDataByAlertLogIdFail(error.message));
  }
}

function* onGetRunbookDetails({ payload: {runbookId} }) {
  try{
    const response = yield call(getRunbookDetailsUrl, runbookId);
    yield put(getRunbookByRunbookIdSuccess(response));
  } catch(error) {
    yield put (getRunbookByRunbookIdFail(error.message))
  }
}

function* onGetRunbookResultsByAlertLogId({ payload: {alertId} }) {
  try {
    const response = yield call(getRunbookResultsUrl, alertId);
    yield put(getRunbookStepsResultsByAlertLogIdSuccess(response));
  } catch (error) {
    yield put(getRunbookStepsResultsByAlertLogIdFail(error.message));
  }
}


function* onGetUserExecutedResultsByAlertLogId({payload:alertId}){
  try {
    const response = yield call(getUserExecutedResultsUrl, alertId);
    yield put(getUserExecutedStepsResultsByAlertLogIdSuccess(response));
  }catch (error) {
    yield put(getUserExecutedStepsResultsByAlertLogIdFail(error.message));
  }
}

function* onGetErrorLogs({payload:{alertId}}) {
  try {
    const response = yield call(getErrorLogsUrl, alertId);
    yield put(getErrorLogsSuccess(response));
  } catch (error) {
    yield put(getErrorLogsFail(error.message));
  }
}

function* onGetAlertLogStatusHistory({payload: {alertId}}) {
  try {
    const response = yield call(getAlertLogStatusHistoryUrl, alertId);
    yield put(getAlertLogStatusHistorySuccess(response));
  } catch (error) {
    yield put(getAlertLogStatusHistoryFail(error.message));
  }
}

function* onExecuteRunbookStep({payload: {data}}){
  try{
    const response = yield call(executeRunbookStepUrl, data)
    yield put (executeRunbookStepSuccess(response))
  } catch(error) {
    yield put (executeRunbookStepFail(error.message))
  }
}

function createStreamingChannel(data) {
  return eventChannel(emitter => {
    let reader = null;

    const startStreaming = async () => {
      try {
        // Use the streaming post function instead
        const response = await postStreaming(url.BASE_URL + "/ai/vibe-debugging", data);
        if (!response.ok) {
          const errorData = await response.json();
          const errorMessage = errorData.message || `HTTP error! status: ${response.status}`;
          throw new Error(errorMessage);
        }

        reader = response.body.getReader();
        const decoder = new TextDecoder();
        let done = false;
        let buffer = ''; // Buffer to accumulate partial chunks

        while (!done) {
          const {value, done: readerDone} = await reader.read();
          done = readerDone;

          if (value) {
            const chunk = decoder.decode(value, {stream: true});
            buffer += chunk;

            // Process complete lines (JSON objects separated by newlines)
            const lines = buffer.split('\n');

            // Keep the last line in buffer (might be incomplete)
            buffer = lines.pop() || '';

            // Process each complete line
            for (const line of lines) {
              const trimmedLine = line.trim();
              if (trimmedLine) {
                try {
                  const parsedChunk = JSON.parse(trimmedLine);

                  if (parsedChunk.error) {
                    emitter({type: 'ERROR', payload: parsedChunk.error});
                    return;
                  } else if (parsedChunk.approval_message) {
                    emitter({type: 'APPROVAL', payload: parsedChunk.approval_message});
                  } else if (parsedChunk.streaming_message) {
                    emitter({type: 'CHUNK', payload: parsedChunk.streaming_message});
                  }
                  // Add more conditions as needed for other message types
                } catch (e) {
                  console.error('Error parsing line:', e);
                  console.log('Raw line that failed to parse:', trimmedLine);
                  // Don't emit error for parsing issues, just log and continue
                  // emitter({type: 'ERROR', payload: `Parse error: ${trimmedLine}`});
                }
              }
            }
          }
        }

        // Process any remaining data in buffer
        if (buffer.trim()) {
          try {
            const parsedChunk = JSON.parse(buffer.trim());
            if (parsedChunk.error) {
              emitter({type: 'ERROR', payload: parsedChunk.error});
            } else if (parsedChunk.approval_message) {
              emitter({type: 'APPROVAL', payload: parsedChunk.approval_message});
            } else if (parsedChunk.streaming_message) {
              emitter({type: 'CHUNK', payload: parsedChunk.streaming_message});
            }
          } catch (e) {
            console.error('Error parsing final buffer:', e);
            console.log('Final buffer that failed to parse:', buffer);
          }
        }

        emitter({type: 'COMPLETE', alert_log_id: data.alert_log_id});
      } catch (error) {
        console.error('Streaming error:', error);
        emitter({type: 'ERROR', payload: error.message});
      }
    };

    startStreaming();

    return () => {
      console.log('Cleaning up stream...');
      if (reader) {
        reader.cancel();
      }
    };
  });
}

function* onStartAiConversation({payload: data}) {
  let channel = null;

  try {
    yield put(setAiStreaming(true));
    yield put(clearAiResponse());

    channel = yield call(createStreamingChannel, data);

    // Listen to channel events
    while (true) {
      const action = yield take(channel);

      if (action.type === 'CHUNK') {
        yield put(updateAiResponseChunk(action.payload));
      } else if (action.type === 'APPROVAL') {
        yield put(handleApprovalMessage(action.payload));
      } else if (action.type === 'ERROR') {
        yield put(startAiConversationFail(action.payload));
        break;
      } else if (action.type === 'COMPLETE') {
        yield put(startAiConversationSuccess());
        yield put({type: GET_PAST_AI_CONVERSATION, payload: action.alert_log_id});
        break;
      }
    }
  } catch (error) {
    yield put(startAiConversationFail(error.message));
  } finally {
    yield put(setAiStreaming(false));

    // Close the channel
    if (channel) {
      channel.close();
    }
  }
}

function* onGetPastAiConversations({payload: alertLogId}) {
  try {
    const response = yield call(getPastAiConversationsUrl, alertLogId);
    yield put(getPastAiConversationsSuccess(response));
  } catch (error) {
    yield put(getPastAiConversationsFail(error.message));
  }
}


function* onGetCheckAiAvailability({payload: alertLogId}) {
  try {
    const response = yield call(getCheckAiAvailabilityUrl, alertLogId);
    yield put(getAgentAvailableSuccess(response));
  } catch (error) {
    yield put(getAgentAvailableFail(error.message));
  }
}

function* alertLogSaga() {
  yield takeEvery(SELECT_ALERT, onSelectALert);
  yield takeEvery(GET_ALERT_LOGS, onGetAlertLogs);
  yield takeEvery(GET_ALERT_LOGS_COUNT, onGetAlertLogsCount);
  yield takeEvery(POST_ACKNOWLEDGE_ALERT, onPostAcknowledgeAlert);
  yield takeEvery(POST_RESOLVE_ALERT, onPostResolveAlert);
  yield takeEvery(GET_ALERT_LOG_DETAILS, onGetAlertLogDetails);
  yield takeEvery(GET_RUNBOOK, onGetRunbook);
  yield takeEvery(POST_RUNBOOK_FEEDBACK, onPostRunbookFeedback);
  yield takeEvery(GET_INTEGRATION_TYPES, onGetIntegrationTypes)
  yield takeEvery(GET_RUNBOOK_FEEDBACKS, onGetRunbookFeedbacks);
  yield takeEvery(POST_RUNBOOK, onPostRunbook);
  yield takeEvery(UPDATE_RUNBOOK, onUpdateRunbook);
  yield takeEvery(GET_ALERT_CORRELATION, onGetAlertCorrelation);
  yield takeEvery(GET_ERROR_LOGS, onGetErrorLogs);
  yield takeEvery(GET_METRIC_DATA_BY_ALERT_LOG_ID, onGetMetricDetails);
  yield takeEvery(GET_RUNBOOK_BY_RUNBOOK_ID, onGetRunbookDetails);
  yield takeEvery(GET_ALERT_LOG_STATUS_HISTORY, onGetAlertLogStatusHistory);
  yield takeEvery(GET_RUNBOOK_RESULTS_ALERT_LOG_ID, onGetRunbookResultsByAlertLogId);
  yield takeEvery(EXECUTE_RUNBOOK_STEP, onExecuteRunbookStep);
  yield takeEvery(START_AI_CONVERSATION, onStartAiConversation);
  yield takeEvery(SEND_APPROVAL_DECISION, onStartAiConversation);
  yield takeEvery(GET_PAST_AI_CONVERSATION, onGetPastAiConversations);
  yield takeEvery(GET_AGENT_AVAILABILITY_FOR_ALERT_LOG, onGetCheckAiAvailability);
  yield takeEvery(GET_USER_EXECUTED_RESULTS_ALERT_LOG_ID, onGetUserExecutedResultsByAlertLogId);
}

export default alertLogSaga;